export default "__VITE_ASSET__CsI_u9$0__";